<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class="row mx-none">
  <div class="col-12 error-page-content">
    <h1>{{'not-found.errorMessage' | translate}}</h1>
    <h2>{{'not-found.title' | translate}}</h2>
    <p>{{'not-found.message' | translate}}</p>
    <button type="button" pButton [label]="'not-found.back' | translate" (click)="goToDashboard()" data-testid="go-to-dashboard-btn"></button>
  </div>
</div>


